import { HoverCard, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { CollectionQuery, Order } from "../../../models/collection.model";
import {
  EntityConfig,
  entityViewMode
} from "../../../models/entity-config.model";
import { Employee } from "../../../models/employee.model";
import EntityList from "../../../shared/component/entity-list/entity-list.component";
import { useLazyGetEmployeesQuery } from "../store/employee.query";

export default function EmployeePage() {
  const params = useParams();
  const location = useLocation();
  const [viewMode, setViewMode] = useState<entityViewMode>("list");
  const [collection, setCollection] = useState<CollectionQuery>({
    skip: 0,
    top: 10,
    orderBy: [{ field: "createdAt", direction: "desc" }],
  });

  const [getEmployees, employees] = useLazyGetEmployeesQuery();

  useEffect(() => {
    getEmployees(collection);
  }, [collection]);

  useEffect(() => {
    if (params?.id !== undefined) {
      setViewMode("detail");
    } else {
      setViewMode("list");
    }
    if (location.pathname === "/user/archived") {
      setViewMode("detail");
    }
  }, [setViewMode, params?.id, location]);

  const data: Employee[] | undefined = employees.data?.data;

  const config: EntityConfig<Employee> = {
    primaryColumn: { key: "name", name: "Name" },
    detailUrl: "detail",
    rootUrl: "/employee-management/employee",
    identity: "id",
    name: "name",
    visibleColumn: [
      { key: "name", name: "Name",render: (user) => {
        return (
          <Text size="sm" className={user?.deletedAt ? "text-danger" : ""}>
            {user.name}
          </Text>
        );
      } },
      { key: "email", name: "Email" },
      { key: "phoneNumber", name: "Phone" },
      {
        key: "gender",
        name: "Gender",
        render: (value) => {
          return value.gender.toLowerCase() === "male" ? "Male" : "Female";
        },
      },

      {
        key: "archiveReason",
        name: "Archive Reason",
        hideSort: true,
        render: (employee: Employee) => {
          
          if(employee.archiveReason){
            return (
              <HoverCard width={280} shadow="md">
                <HoverCard.Target>
                  <Text size="sm" className={"cursor-pointer"}>
                    {(employee?.archiveReason && employee?.archiveReason?.length > 25)
                      ? employee?.archiveReason?.substring(0, 22) + "..."
                      : employee?.archiveReason}
                  </Text>
                </HoverCard.Target>
                <HoverCard.Dropdown
                  className={"text-justify break-all wrap max-h-60 overflow-auto"}
                >
                  <Text size="sm">{employee.archiveReason}</Text>
                 
                </HoverCard.Dropdown>
              </HoverCard>
            )
          }else{
            return "Not archived";
          }
          
        },
      },
     
      { key: "createdAt", name: "Registered At", isDate: true },
      {
        key: "enabled",
        name: "Status",
      },
    ],
  };

  return (
    <div className="h-full p-4">
      <EntityList
        viewMode={viewMode}
        title={"Employees"}
        total={employees?.data?.count}
        itemsLoading={employees.isFetching}
        config={config}
        items={data}
        initialPage={1}
        defaultPageSize={10}
        pageSize={[10, 15, 20]}
        collectionQuery={collection}
        onArchivedChecked={(e) =>
          setCollection({
            ...collection,
            withArchived: e,
          })
        }
        onPaginationChange={(skip: number, top: number) => {
          if (collection.skip !== skip || collection.top !== top) {
            setCollection({ ...collection, skip: skip, top: top });
          }
        }}
        onSearch={(data: any) => {
          setCollection({
            ...collection,
            search: data,
            searchFrom: ["name", "email", "phoneNumber"],
          });
        }}
        onFilterChange={(data: any) => {
          if(collection?.filter||data.length>0){
            setCollection({ ...collection, filter: data });
           }
        }}
        onOrder={(data: Order) =>
          setCollection({ ...collection, orderBy: [data] })
        }
      />
    </div>
  );
}
